<template>
  <v-parallax height="420px" src="@/assets/sims.png" class="parallax-class">
    <div class="carousel-container">
      <v-carousel
        v-model="currentSlide"
        height="400px"
        show-arrows="hover"
        cycle
        hide-delimiter-background
        color="#d9d9d9"
      >
        <v-carousel-item v-for="(video, i) in videos" :key="i">
          <v-sheet
            height="100%"
            style="background-color: transparent; margin-top: 35px"
          >
            <v-card @click="openDialog(video)" class="mx-auto my-4 hover-card">
              <v-img :src="video.thumbnailURL" class="video-thumbnail"></v-img>
              <!-- <div class="text-center video-title">
                {{ video.title }}
              </div> -->
              <!----
              <div class="days-ago-text">
                {{ formatDaysAgo(video.publishedAt) }}
              </div> -->
            </v-card>
          </v-sheet>
        </v-carousel-item>
      </v-carousel>
    </div>
  </v-parallax>

  <!-- Dialog outside of the carousel -->
  <v-dialog v-model="dialog" max-width="800px">
    <!-- Make sure the container is positioned relative -->
    <div class="video-dialog-container">
      <!-- Close Button (X icon) positioned at the top right -->
      <v-icon class="dialog-close-btn" width="100%" @click="dialog = false"
        >mdi-close</v-icon
      >

      <v-card v-if="selectedVideo" class="mx-auto video-card">
        <img
          :src="selectedVideo.thumbnailURL"
          class="video-card-thumbnail"
          alt="Thumbnail"
        />

        <v-card-title>{{ selectedVideo.title }}</v-card-title>
        <v-card-text>
          {{ selectedVideo.description }}
        </v-card-text>
        <v-card-actions>
          <v-btn
            class="rounded-btn push-right"
            @click="openVideo(selectedVideo.videoURL)"
            target="_blank"
          >
            Watch Video
          </v-btn>
          <!-- Optionally keep the regular "Close" button -->
        </v-card-actions>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import { WS } from "@/services/WS";

export default {
  name: "VideoCard",
  props: {
    videos: {
      type: Array,
      required: true,
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 225,
    },
    cropThumbnail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentSlide: 0,
      dialog: false,
      selectedVideo: null,
    };
  },
  methods: {
    formatDaysAgo(dateString) {
      if (!dateString) return "Unknown date";
      const publishedDate = new Date(dateString);
      const currentDate = new Date();
      const differenceInTime = currentDate - publishedDate;
      const differenceInDays = Math.floor(
        differenceInTime / (1000 * 60 * 60 * 24)
      );

      return differenceInDays === 0
        ? "Today"
        : differenceInDays === 1
        ? "1 day ago"
        : `${differenceInDays} days ago`;
    },
    openDialog(video) {
      this.selectedVideo = video;
      this.dialog = true;
    },
    openVideo(videoUrl) {
      if (videoUrl) {
        WS.recordUsage(videoUrl);
        window.open(videoUrl, "_blank");
      }
      this.dialog = false;
    },
  },
};
</script>

<style>
.v-dialog {
  z-index: 1000 !important;
}
</style>
